var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 946,
    height: 1225,
    viewBox: "0 0 946 1225",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1649_33389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.593 503.644C350.01 605.43 477.7 694.391 562.863 734.374C648.026 774.357 619.638 1041.24 720.781 926.261C767.72 872.9 777.616 819.162 781.588 741.96C791.023 558.567 683.764 431.721 598.601 391.738C513.438 351.756 417.176 401.857 383.593 503.644Z",
    fill: "#FF90EA",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1649_33389",
    x: 0.65506,
    y: 0.539825,
    width: 1158.95,
    height: 1331.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 188.718,
    result: "effect1_foregroundBlur_1649_33389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector4.c0c0cf82e3f7495ceefb2f7592b689f9.svg";
export { ForwardRef as ReactComponent };